<table
  id="missing-ref-id-table"
  mat-table
  class="mat-elevation-z1"
  [dataSource]="dataSource"
>
  <ng-container matColumnDef="remaining_amount">
    <th
      *matHeaderCellDef
      mat-header-cell
    >
      Fennálló követelés
    </th>
    <td
      *matCellDef="let element"
      mat-cell
    >
      {{ element.remaining_amount | number: "1.0" : "hu" }}
      {{ element.currency_iso }}
    </td>
  </ng-container>

  <ng-container matColumnDef="original_amount">
    <th
      *matHeaderCellDef
      mat-header-cell
    >
      Teljes követelés
    </th>
    <td
      *matCellDef="let element"
      mat-cell
    >
      {{ element.original_amount | number: "1.0" : "hu" }}
      {{ element.currency_iso }}
    </td>
  </ng-container>

  <ng-container matColumnDef="due_date_at">
    <th
      *matHeaderCellDef
      mat-header-cell
    >
      Fizetési határidő
    </th>
    <td
      *matCellDef="let element"
      mat-cell
    >
      {{ element.due_date_at | date: "yyyy.MM.dd." }}
    </td>
  </ng-container>

  <ng-container matColumnDef="invoice_file_name">
    <th
      *matHeaderCellDef
      mat-header-cell
    >
      Számla PDF neve
    </th>
    <td
      *matCellDef="let element"
      mat-cell
    >
      {{ element.invoice_file_name }}
    </td>
  </ng-container>

  <ng-container matColumnDef="set_invoice">
    <th
      *matHeaderCellDef
      mat-header-cell
    ></th>
    <td
      *matCellDef="let element"
      mat-cell
    >
      <button
        payee-button
        width="short"
        height="short"
        (click)="openSetInvoiceDialog(element)"
      >
        Számla kiválasztása
      </button>
    </td>
  </ng-container>

  <tr
    *matHeaderRowDef="displayedColumns"
    mat-header-row
  ></tr>
  <tr
    *matRowDef="let row; columns: displayedColumns"
    mat-row
  ></tr>
</table>
<mat-paginator
  id="missing-ref-id-invoice-paginator"
  showFirstLastButtons
  [pageIndex]="page"
  [pageSize]="perPage"
  [length]="length"
  (page)="setClaims($event)"
></mat-paginator>
